import { useNavigate } from 'react-router-dom'

export const SCAN_PRINTER_URL = '/assembly/printer/:transferId/:docNum'

export const useGoToScanPrinter = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string, redirectOnSuccess?: boolean) => {
      const url = redirectOnSuccess
        ? `${SCAN_PRINTER_URL}?redirectOnSuccess=true`
        : SCAN_PRINTER_URL
      navigate(
        url.replace(':transferId', transferId).replace(':docNum', docNum)
      )
    }
  }
}
